<template lang="pug">
div(class="d-flex flex-column flex-grow-1 min-h-0 tw-h-full fill-height overflow-hidden")
  //Header
  //- div(class=" tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pb-1 tw-text-left")
  //-   v-row
  //-     v-col
  //-       span(class=" tw-text-2xl text-secondary tw-font-bold ") Close Opportunity

  //Content
  div(class=" tw-flex tw-h-full tw-flex-row tw-flex-grow tw-p-0 tw-pb-0 tw-pl-0 tw-overflow-hidden  ")
    v-stepper(v-model="step" flat elevation="0" class="tw-shadow-none tw-w-full mx-0 px-0 tw-flex ")
      v-stepper-items(class="tw-w-full  ")
        v-stepper-content(step="1" class=" tw-my-0 tw-py-0 px-2 tw-w-full ")
          div(class="tw-h-20")
          v-container(fluid class="tw-w-full")
            v-row(no-gutters class=" tw-w-full")
              v-col(class="tw-text-center")
                span(class=" tw-text-xl text-gray tw-font-bold") Did we win this opportunity?
            v-row(dense justify="space-around" class=" mx-10 mt-6")
              v-col(cols="auto" class="")
                v-btn-toggle(v-model="toggle" rounded borderless class="tw-w-full")
                  v-row(class="tw-w-full")
                    v-col
                      v-btn(
                        icon
                        color=" blue-grey lighten-2"
                        elevation="0"
                        width="120"
                        height="120"
                        outlined
                        @click="outcome = 1"
                      )
                        v-container(class=" tw-w-auto")
                          v-row(no-gutters align="center" justify="center")
                            v-col
                              v-icon mdi-thumb-up-outline
                          v-row(no-gutters align="center" justify="center" class="mt-1")
                            v-col
                              span Yes!

                    v-col
                      v-btn(
                        icon
                        color=" blue-grey lighten-2"
                        elevation="0"
                        width="120"
                        height="120"
                        outlined
                        @click="outcome = 2"
                      )
                        v-container(class=" tw-w-auto")
                          v-row(no-gutters align="center" justify="center")
                            v-col
                              v-icon mdi-thumb-down-outline
                          v-row(no-gutters align="center" justify="center" class="mt-1")
                            v-col
                              span No

        v-stepper-content(step="2" class="tw-my-0 tw-py-0 tw-w-full")
          v-container(v-if="outcome == 1" class="tw-w-full pa-0 ma-0" :key="key")
            v-row(justify="center" class="tw-w-full tw-pt-4")
              v-col(cols="auto" class=" tw-text-center")
                v-row(no-gutters align="center" jusfify="center")
                  v-col(cols="auto" class="tw-ml-12")
                    span(class=" tw-text-xl text-gray tw-font-bold") Congratulations!!
                  v-col(cols="auto" class="")
                    v-lottie-player(
                      :loop="true"
                      width="100px"
                      height="100px"
                      :animationData="require('@/assets/animations/success.json')"
                      class="pa-0 tw--ml-6 tw--mt-6 tw--mb-2"
                    )
            v-row(dense class="text-gray")
              v-col(class="tw-mt-4")
                span Is the value of the opportunity correct?
            v-row(no-gutters class="text-gray")
              v-col(class="tw-mt-1")
                v-text-field(
                  v-model="opportunity.amount"
                  type="number"
                  reverse
                  append-icon="mdi-currency-usd"
                  outlined
                  hide-details
                )
            v-row(class="text-gray")
              v-col
                span Add a few closing notes that could help in the future.
            v-row(no-gutters)
              v-col(class="tw-mt-1")
                v-textarea(
                  v-model="opportunity.closing_notes"
                  no-resize
                  rows="7"
                  hide-details
                  outlined
                  height="150"
                )
          v-container(v-if="outcome == 2" :key="key")
            v-row
              v-col(cols="auto" class=" tw-pt-8")
                span(class=" tw-text-xl text-gray tw-font-bold") Maybe next time!
            v-row(class="text-gray")
              v-col
                span Add a few closing notes that could help in the future.
            v-row(no-gutters class="text-gray")
              v-col(class="tw-mt-1")
                v-textarea(
                  v-model="opportunity.closing_notes"
                  no-resize
                  rows="7"
                  hide-details
                  outlined
                  height="150"
                )

  //Buttons
  div(class="tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pt-1 ")
    v-row(justify="end" align-self="end" align="end" class="tw-bottom-0")
      v-col(cols="auto" align-end class="tw-h-full fill-height")
        v-btn(v-if="step == 1" @click="$emit('close')" text :ripple="false")
          span(class=" tw-text-kPurple tw-mt-4") Cancel
        v-btn(
          v-if="step == 2"
          @click="(step = 1), key++"
          text
          :disabled="loading"
          :ripple="false"
        )
          span(class=" tw-text-kPurple tw-mt-4") Back
        v-btn(
          v-if="step == 1"
          :disabled="!outcome"
          depressed
          color="rgba(94,129,244,0.80)"
          @click="step++, key++"
        )
          span(class="tw-font-bold") Next
        v-btn(
          v-if="step == 2"
          depressed
          color="rgba(94,129,244,0.80)"
          :loading="loading"
          @click="save"
        )
          span(class="tw-font-bold") Save
</template>
<script>
export default {
  props: ['opportunity'],
  data() {
    return {
      loading: false,
      step: 1,
      outcome: null,
      toggle: null,
      key: 1,
    };
  },
  methods: {
    save() {
      this.loading = true;
      this.opportunity.closed_state = this.outcome;
      this.$store
        .dispatch('opportunities/update', this.opportunity)
        .then(() => {
          this.loading = false;
          this.$emit('close');
        })
        .catch((error) => {
          commit('SET_ERROR', error, { root: true });
        });
    },
  },
};
</script>
<style lang="stylus">

.close-opp-modal {
  height: 70vh !important;
  max-height: 580px !important;
}
.on-hover {
  @apply tw-shadow-md tw-bg-green-lighten-2;


}
</style>
